import React, { Component, ErrorInfo, ReactNode } from 'react';
import logger from '~/services/logger';
import spiderSense, { Severity } from '~/services/spidersense';
import OnAirErrorFallback from './OnAirErrorFallback';

interface Props {
	children: ReactNode;
	webinarId: string;
}

interface State {
	hasError: boolean;
	error: Error | null;
}

class OnAirErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		const { webinarId } = this.props;

		spiderSense.track({
			severity: Severity.ERROR,
			categories: ['onair', 'watch-page-error'],
			info: {
				message: error.message,
				stack: error.stack || '',
				componentStack: errorInfo.componentStack || '',
				webinarId,
				url: window.location.pathname,
			},
		});

		logger.captureException({
			error,
			message: 'watchPage::React error boundary caught error',
			tags: { onair: true },
			extra: {
				componentStack: errorInfo.componentStack,
				webinarId,
			},
		});
	}

	override render() {
		if (this.state.hasError) {
			return <OnAirErrorFallback webinarId={this.props.webinarId} />;
		}

		return this.props.children;
	}
}

export default OnAirErrorBoundary;
